module.exports = __webpack_public_path__ + "img/registerlogin_1.7e24b4bc.jpg";